import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { GET_SERVICE_DETAILS_FAILURE, GET_SERVICE_DETAILS_SUCCESS, getServiceDetails, SET_LOADER, UPDATE_SERVICE_DETAILS_FAILURE, UPDATE_SERVICE_DETAILS_SUCCESS, updateService, updateServiceDetails, UPLOAD_TERMS_AND_CONDITIONS_FAILURE } from '../../Redux/Actions/Actions'
import UploadComponent from '../Reusable_Components/UploadComponent'
import Loader from '../Reusable_Components/loader'
import axios from 'axios'
import { base_url } from '../../utilities'
import { Button, Modal } from 'react-bootstrap'
import { MdErrorOutline } from 'react-icons/md'
import DatePicker from 'react-datepicker';
import TableComponent from '../Reusable_Components/TableComponent.jsx'
import { eleminateSpacesAtStartOfInputField } from '../Reusable_Components/ReusableFunctions'
import Footer from "../Login/Footer.jsx";

export default function EditService(props) {

    const dispatch = useDispatch()

    const serviceDetails = useSelector(state => state.serviceDetails)
    const getServiceDetailsError = useSelector(state => state.getServiceDetailsError)
    const loading = useSelector(state => state.loading)
    const updateServiceSuccess = useSelector(state => state.updateServiceSuccess)
    const updateServiceError = useSelector(state => state.updateServiceError)

    const [edit, setEdit] = useState(false)
    const [hsnCodeError, setHsnCodeError] = useState("");
    const [cgstError, setCgstError] = useState("");
    const [sgstError, setSgstError] = useState("");
    const [igstError, setIgstError] = useState("");
    const [biilingPeriodFilter, setBillingPeriodFilter] = useState(new Date())
    const [taxRatesBillingFilter, setTaxRatesBillingFilter] = useState(new Date())
    const [viewHsnRecordsModal, setViewHsnRecordsModal] = useState(false)
    const [hsnCodes, setHsnCodes] = useState([])
    const [hsnCodeErrorModal, setHsnCodeErrorModal] = useState(null)
    const [viewTaxRatesModal, setViewTaxRatesModal] = useState(false)
    const [taxRates, setTaxRates] = useState([])
    const [taxRatesError, setTaxRatesError] = useState(null)
    const [tdsPercentageError, setTdsPercentageError] = useState(null)
    const [viewInvoiceTermsModal, setViewInvoiceTermsModal] = useState(false)
    const [invoiceTerms, setInvoiceTerms] = useState([])
    const [invoiceTermsError, setInvoiceTermsError] = useState(null)

    useEffect(() => {
        dispatch(getServiceDetails(props.serviceId))
    }, [])

    const handleUpdateService = () => {
        const data = {
            service_type_id: serviceDetails?.service?.service_type_id,
            service_description: serviceDetails?.service?.service_description,
            invoice_name: serviceDetails?.service?.invoice_name,
            invoice_description: serviceDetails?.service?.invoice_description,
            invoice_frequency: serviceDetails?.service?.invoice_frequency,
            invoice_generation_day: serviceDetails?.service?.invoice_generation_day,
            invoice_cutoff_day: serviceDetails?.service?.invoice_cutoff_day,
            pre_pay_ind: serviceDetails?.service?.pre_pay_ind?1:0,
            charge_by_consumption_ind: serviceDetails?.service?.charge_by_consumption_ind?1:0,
            allow_prorate_billing_ind: serviceDetails?.service?.allow_prorate_billing_ind?1:0,
            hsn_code: serviceDetails?.hsn_code?.hsn_code,
            hsncode_effective_from_month: biilingPeriodFilter.getMonth() + 1,
            hsncode_effective_from_year: biilingPeriodFilter.getFullYear(),
            cgst: parseFloat(serviceDetails?.tax_rates?.cgst),
            sgst: parseFloat(serviceDetails?.tax_rates?.sgst),
            igst: parseFloat(serviceDetails?.tax_rates?.igst),
            taxrates_effective_from_month: taxRatesBillingFilter.getMonth() + 1,
            taxrates_effective_from_year: taxRatesBillingFilter.getFullYear(),
            tds_percentage: parseFloat(serviceDetails?.tax_rates?.tds_percentage),
            uom: serviceDetails?.service?.uom,
        }
        dispatch(updateService(data))
    }

    const getHsnCodes = (service_code) => {
        dispatch({
            type: SET_LOADER,
            payload: true
        })
        axios.get(base_url + `customers/serviceTypes/hsnCodes?filter_condition=%7B%22service_code%22%3A%20%22${service_code}%22%7D`)
            .then((res) => {
                if (res.status === 200) {
                    setHsnCodes(res.data.data)
                    dispatch({
                        type: SET_LOADER,
                        payload: false
                    })
                }
            })
            .catch((err) => {
                setHsnCodeErrorModal(err.response.data.message)
                dispatch({
                    type: SET_LOADER,
                    payload: false
                })
            })
    }

    const getTaxRates = (service_code) => {
        dispatch({
            type: SET_LOADER,
            payload: true
        })
        axios.get(base_url + `customers/serviceTypes/taxRates?filter_condition=%7B%22service_code%22%3A%20%22${service_code}%22%7D`)
            .then((res) => {
                if (res.status === 200) {
                    setTaxRates(res.data.data)
                    dispatch({
                        type: SET_LOADER,
                        payload: false
                    })
                }
            })
            .catch((err) => {
                setTaxRatesError(err.response.data.message)
                dispatch({
                    type: SET_LOADER,
                    payload: false
                })
            })
    }

    const getInvoiceTerms = (service_code, document_type) => {
        dispatch({
            type: SET_LOADER,
            payload: true
        })
        axios.get(base_url + `customers/serviceTypes/invoiceTerms?filter_condition=%7B%22service_code%22%3A%20%22${service_code}%22%2C%20%22document_type%22%3A%20%22${document_type}%22%7D`)
            .then((res) => {
                if (res.status === 200) {
                    setInvoiceTerms(res.data.data)
                    dispatch({
                        type: SET_LOADER,
                        payload: false
                    })
                }
            })
            .catch((err) => {
                setInvoiceTermsError(err.response.data.message)
                dispatch({
                    type: SET_LOADER,
                    payload: false
                })
            })
    }
    const [showBackConfirmation, setShowBackConfirmation] = useState(false)
    const handleBack = () => setShowBackConfirmation(false);
    const handleProceed = () => {
        setShowBackConfirmation(false);
    }

    return (
        <div className="addUserContainer">
            <div className="stepsContainer">
                <div className="stepsTitle">
                    <h6 className='stepsTitle_heading'>Edit Service</h6>
                </div>
                <div className={'stepsCardActive'}>
                    <div className='stepsCardHeader'>
                        <span className='stepsCardTitle '>Service Information</span>
                    </div>
                    <span className='stepsCardDescription'>Service Details</span>
                </div>
            </div>
            <div className="infoContainer">
                <div className="infoTitle">
                    <h6 className='stepsTitle_heading'>Service Information</h6>
                </div>
                <div className="infoForm">
                    <div className="infoBody">
                        <h6>Service details</h6>
                        <div className="d-flex gap-3 flex-wrap">
                            <div>
                                <label className='add-facility-modal-label'>Service Name<span className='required-mark'>*</span></label>
                                <input type='text' className='form-control responsive-add-facility-input-fields'
                                    placeholder='Eg: Space liscese fee, ELectricity etc'
                                    disabled
                                    value={serviceDetails?.service?.service_name}
                                />
                                {/* <span style={{ color: "red", fontSize: "small" }}>{serviceNameError}</span> */}
                            </div>
                            <div>
                                <label className='add-facility-modal-label'>Service Code (max 20 characters)<span className='required-mark'>*</span></label>
                                <input type='text' className='form-control responsive-add-facility-input-fields'
                                    placeholder='Eg: slf, electricity,water,misc etc'
                                    disabled
                                    value={serviceDetails?.service?.service_code}
                                />
                                {/* <span style={{ color: "red", fontSize: "small" }}>{serviceCodeError}</span> */}
                            </div>
                            <div>
                                <label className='add-facility-modal-label'>Unit of Measurement<span style={{ color: "red" }}>*</span></label>
                                <input type='text' className='form-control responsive-add-facility-input-fields'
                                    placeholder='Eg: sq.ft'
                                    disabled={!edit}
                                    value={serviceDetails?.service?.uom}
                                    onChange={(e) => {
                                        let value = e.target.value;
                                        if (/\d/.test(value)) {
                                                return;
                                            }
                                        dispatch({
                                            type: GET_SERVICE_DETAILS_SUCCESS,
                                            payload: { ...serviceDetails, service: { ...(serviceDetails?.service), uom: eleminateSpacesAtStartOfInputField(e.target.value) } }
                                        })
                                    }
                                    }
                                />
                                {/* <span style={{ color: "red", fontSize: "small" }}>{serviceCodeError}</span> */}
                            </div>
                        </div>
                        <div className="inputsSection">
                            <div style={{ width: "100%" }}>
                                <label className='add-facility-modal-label'>Service Description<span className='required-mark'>*</span></label>
                                <textarea className='form-control styled-textarea'
                                    placeholder='Description of the service'
                                    disabled={!edit}
                                    onChange={(e) => {
                                        dispatch({
                                            type: GET_SERVICE_DETAILS_SUCCESS,
                                            payload: { ...serviceDetails, service: { ...(serviceDetails?.service), service_description: eleminateSpacesAtStartOfInputField(e.target.value) } }
                                        })
                                    }}
                                    value={serviceDetails?.service?.service_description}
                                />
                                {/* <span style={{ color: "red", fontSize: "small" }}>{serviceDescriptionError}</span> */}
                            </div>
                        </div>
                        <hr />
                        <h6>Invoice Information</h6>
                        <div className="inputsSection">
                            <div>
                                <label className='add-facility-modal-label'>Service name in Invoice<span className='required-mark'>*</span></label>
                                <input type='text' className='form-control responsive-add-facility-input-fields'
                                    placeholder='Eg: slf, electricity etc'
                                    disabled={!edit}
                                    value={serviceDetails?.service?.invoice_name}
                                    onChange={(e) => {
                                        dispatch({
                                            type: GET_SERVICE_DETAILS_SUCCESS,
                                            payload: { ...serviceDetails, service: { ...(serviceDetails?.service), invoice_name: eleminateSpacesAtStartOfInputField(e.target.value) } }
                                        })
                                    }
                                    }
                                />
                            </div>
                        </div>
                        <div className="inputsSection">
                            <div style={{ width: "100%" }}>
                                <label className='add-facility-modal-label'>Invoice Description<span className='required-mark'>*</span></label>
                                <textarea className='form-control styled-textarea'
                                    placeholder='Description of the invoice'
                                    disabled={!edit}
                                    value={serviceDetails?.service?.invoice_description}
                                    onChange={(e) => {
                                        dispatch({
                                            type: GET_SERVICE_DETAILS_SUCCESS,
                                            payload: { ...serviceDetails, service: { ...(serviceDetails?.service), invoice_description: eleminateSpacesAtStartOfInputField(e.target.value) } }
                                        })
                                    }
                                    }
                                />
                                {/* <span style={{ color: "red", fontSize: "small" }}>{invoiceDescriptionError}</span> */}
                            </div>
                        </div>
                        <div className="inputsSection">
                            <div>
                                <label className='add-facility-modal-label'>Frequency<span className='required-mark'>*</span></label>
                                <select className='form-select responsive-add-facility-input-fields custom-select-input' value={serviceDetails?.service?.invoice_frequency} disabled={!edit}
                                    onChange={(e) => {
                                        dispatch({
                                            type: GET_SERVICE_DETAILS_SUCCESS,
                                            payload: { ...serviceDetails, service: { ...(serviceDetails?.service), invoice_frequency: e.target.value } }
                                        })
                                    }
                                    }
                                >
                                    <option value="" hidden>Select</option>
                                    <option value="monthly">Monthly</option>
                                    <option value="quarterly">Quarterly</option>
                                    <option value="yearly">Yearly</option>
                                </select>
                            </div>
                            <div>
                                <label className='add-facility-modal-label'>Invoice generation day<span className='required-mark'>*</span></label>
                                <select className='form-select responsive-add-facility-input-fields custom-select-input'
                                    disabled={!edit}
                                    value={serviceDetails?.service?.invoice_generation_day}
                                    onChange={(e) => {
                                        dispatch({
                                            type: GET_SERVICE_DETAILS_SUCCESS,
                                            payload: { ...serviceDetails, service: { ...(serviceDetails?.service), invoice_generation_day: e.target.value } }
                                        })
                                    }
                                    }
                                >
                                    <option value="" hidden>Select</option>
                                    <option value="22">22</option>
                                    <option value="23">23</option>
                                    <option value="24">24</option>
                                    <option value="25">25</option>
                                    <option value="26">26</option>
                                    <option value="27">27</option>
                                    <option value="28">28</option>
                                </select>
                            </div>
                            <div>
                                <label className='add-facility-modal-label'>Invoice Cut-off day<span className='required-mark'>*</span></label>
                                <input type='text' disabled={!edit} className='form-control responsive-add-facility-input-fields'
                                    value={serviceDetails?.service?.invoice_cutoff_day}
                                    onChange={(e) => {
                                        dispatch({
                                            type: GET_SERVICE_DETAILS_SUCCESS,
                                            payload: { ...serviceDetails, service: { ...(serviceDetails?.service), invoice_cutoff_day: e.target.value } }
                                        })
                                    }
                                    }
                                />
                            </div>
                        </div>
                        <div className="inputsSection">
                            <div className="checkboxHolder">
                                <input type='checkbox' id='prepaid' className="inputCheckbox"
                                    checked={serviceDetails?.service?.pre_pay_ind}
                                    disabled={!edit}
                                    onChange={(e) => {
                                        dispatch({
                                            type: GET_SERVICE_DETAILS_SUCCESS,
                                            payload: { ...serviceDetails, service: { ...(serviceDetails?.service), pre_pay_ind: e.target.checked, charge_by_consumption_ind: e.target.checked && false } }
                                        })
                                    }
                                    }
                                />
                                <label className='add-facility-modal-label' htmlFor='prepaid'>Pre Paid</label>
                            </div>
                            <div className="checkboxHolder">
                                <input type='checkbox' id='consumption'
                                    className="inputCheckbox"
                                    checked={serviceDetails?.service?.charge_by_consumption_ind}
                                    disabled={!edit}
                                    onChange={(e) => {
                                        dispatch({
                                            type: GET_SERVICE_DETAILS_SUCCESS,
                                            payload: { ...serviceDetails, service: { ...(serviceDetails?.service), charge_by_consumption_ind: e.target.checked, pre_pay_ind: e.target.checked && false } }
                                        })
                                    }
                                    }
                                />
                                <label className='add-facility-modal-label' htmlFor='consumption'>Charge by consumption</label>
                            </div>
                            <div className="checkboxHolder">
                                <input type='checkbox' className="inputCheckbox" id='prorate'
                                    checked={serviceDetails?.service?.allow_prorate_billing_ind}
                                    disabled={!edit}
                                    onChange={(e) => {
                                        dispatch({
                                            type: GET_SERVICE_DETAILS_SUCCESS,
                                            payload: { ...serviceDetails, service: { ...(serviceDetails?.service), allow_prorate_billing_ind: e.target.checked } }
                                        })
                                    }
                                    }
                                />
                                <label className='add-facility-modal-label' htmlFor='prorate' >Pro rate billing</label>
                            </div>
                        </div>
                        <hr />
                        <div className='service-details-form-group'>
                            <h6>HSN Code</h6>
                            <div className="d-flex gap-3 flex-wrap">
                                <div>
                                    <label className='add-facility-modal-label'>HSN Code<span className='required-mark'>*</span></label>
                                    <input type='text'
                                        onWheel={(e) => e.target.blur()}
                                        disabled={!edit} value={serviceDetails?.hsn_code?.hsn_code}
                                        className='noSpinArrows form-control responsive-add-facility-input-fields'
                                        placeholder='Eg: 123456 or 12345678'
                                        onChange={(e) => {
                                            const input = e.target.value.replace(/[^0-9]/g, '');
                                            dispatch({
                                                type: GET_SERVICE_DETAILS_SUCCESS,
                                                payload: { ...serviceDetails, hsn_code: { ...(serviceDetails?.hsn_code), hsn_code: input } }
                                            });
                                            if (input === "") {
                                                setHsnCodeError("HSN Code is required");
                                            } else if (!/^\d{6}$|^\d{8}$/.test(input)) {
                                                setHsnCodeError("Invalid HSN Code");
                                            } else {
                                                setHsnCodeError("");
                                            }
                                        }}
                                    />
                                    <span className='input-error-text'>{hsnCodeError}</span>
                                </div>
                                {edit && <div className='d-flex flex-column'>
                                    <label className='add-facility-modal-label form-label-effective-from '>Effective from<span className='required-mark'>*</span></label>
                                    <DatePicker 
                                        disabled={!edit}
                                        className="admin-controls-date-picker form-control responsive-add-facility-input-fields custom-datepicker"
                                        placeholderText="Select Period"
                                        selected={biilingPeriodFilter}
                                        onChange={(date) => setBillingPeriodFilter(date)}
                                        showMonthYearPicker
                                        dateFormat="MMM yyyy"
                                    />
                                </div>}

                                <div>
                                    <label className='add-facility-modal-label'>TDS Percentage<span className='required-mark'>*</span></label>
                                    <input type='text'
                                        onWheel={(e) => e.target.blur()}
                                        disabled={!edit}
                                        value={serviceDetails?.tax_rates?.tds_percentage}
                                        className='noSpinArrows form-control responsive-add-facility-input-fields'
                                        placeholder='Eg: 1'
                                        onChange={(e) => {
                                            let input = e.target.value.replace(/[^0-9.]/g, '');
                                            const decimalIndex = input.indexOf('.');
                                            if (decimalIndex !== -1) {
                                                const integerPart = input.slice(0, decimalIndex);
                                                const decimalPart = input.slice(decimalIndex + 1, decimalIndex + 3);
                                                input = `${integerPart}.${decimalPart}`;
                                            }
                                            dispatch({
                                                type: GET_SERVICE_DETAILS_SUCCESS,
                                                payload: { ...serviceDetails, tax_rates: { ...(serviceDetails?.tax_rates), tds_percentage: input } }
                                            });
                                            if (input === "") {
                                                setTdsPercentageError("TDS Percentage is required");
                                            } else if (isNaN(input) || parseFloat(input) < 0 || parseFloat(input) > 100) {
                                                setTdsPercentageError("Invalid TDS Percentage");
                                            } else {
                                                setTdsPercentageError("");
                                            }
                                        }}
                                    />
                                    <span className='input-error-text'>{tdsPercentageError}</span>
                                </div>

                                <span className='view-records-button' role='button'
                                    onClick={() => {
                                        setViewHsnRecordsModal(true)
                                        getHsnCodes(serviceDetails?.service?.service_code)
                                    }}
                                >View previous records</span>
                            </div>
                        </div>
                        <hr />
                        <div className='service-details-form-group'>
                            <h6>Tax rates</h6>
                            <b>Intra State: </b>
                            <div className="d-flex gap-3 flex-wrap tax-rates-container">
                                <div>
                                    <label className='add-facility-modal-label'>CGST (0, 2.5, 6, 9, 14)<span className='required-mark'>*</span></label>
                                    <input type='text'
                                        onWheel={(e) => e.target.blur()}
                                        disabled={!edit} value={serviceDetails?.tax_rates?.cgst}
                                        className='noSpinArrows form-control responsive-add-facility-input-fields'
                                        onChange={(e) => {
                                            let value = e.target.value.replace(/[^0-9.]/g, '');
                                            dispatch({
                                                type: GET_SERVICE_DETAILS_SUCCESS,
                                                payload: { ...serviceDetails, tax_rates: { ...(serviceDetails?.tax_rates), cgst: value, sgst: value, igst: value * 2 } }
                                            })
                                            if (value === "") {
                                                setCgstError("CGST is required")
                                                setSgstError("SGST is required")
                                                setIgstError("IGST is required")
                                            } else if (![0, 2.5, 6, 9, 14].includes(parseFloat(value))) {
                                                setCgstError("Invalid CGST value")
                                                setSgstError("Invalid SGST value")
                                                setIgstError("Invalid IGST value")
                                            } else {
                                                setCgstError("")
                                                setSgstError("")
                                                setIgstError("")
                                            }
                                        }}
                                    />
                                    <span className='input-error-text'>{cgstError}</span>
                                </div>
                                <div>
                                    <label className='add-facility-modal-label'>SGST (0, 2.5, 6, 9, 14)<span className='required-mark'>*</span></label>
                                    <input type='text'
                                        onWheel={(e) => e.target.blur()}
                                        disabled={!edit} value={serviceDetails?.tax_rates?.sgst}
                                        className='noSpinArrows form-control responsive-add-facility-input-fields'
                                        onChange={(e) => {
                                            let value = e.target.value.replace(/[^0-9.]/g, '');
                                            dispatch({
                                                type: GET_SERVICE_DETAILS_SUCCESS,
                                                payload: { ...serviceDetails, tax_rates: { ...(serviceDetails?.tax_rates), sgst: value, cgst: value, igst: value * 2 } }
                                            })
                                            if (value === "") {
                                                setCgstError("CGST is required")
                                                setSgstError("SGST is required")
                                                setIgstError("IGST is required")
                                            } else if (![0, 2.5, 6, 9, 14].includes(parseFloat(value))) {
                                                setCgstError("Invalid CGST value")
                                                setSgstError("Invalid SGST value")
                                                setIgstError("Invalid IGST value")
                                            } else {
                                                setCgstError("")
                                                setSgstError("")
                                                setIgstError("")
                                            }
                                        }}
                                    />
                                    <span className='input-error-text'>{sgstError}</span>
                                </div>
                            </div>
                            <b>Inter State: </b>
                            <div className="d-flex gap-5 flex-wrap">
                                <div>
                                    <label className='add-facility-modal-label'>IGST (0, 5, 12, 18, 28)<span className='required-mark'>*</span></label>
                                    <input type='text'
                                        onWheel={(e) => e.target.blur()}
                                        disabled={!edit} value={serviceDetails?.tax_rates?.igst}
                                        className='noSpinArrows form-control responsive-add-facility-input-fields'
                                        onChange={(e) => {
                                            let value = e.target.value.replace(/[^0-9.]/g, '');
                                            dispatch({
                                                type: GET_SERVICE_DETAILS_SUCCESS,
                                                payload: { ...serviceDetails, tax_rates: { ...(serviceDetails?.tax_rates), igst: value, cgst: value / 2, sgst: value / 2 } }
                                            })
                                            if (value === "") {
                                                setCgstError("CGST is required")
                                                setSgstError("SGST is required")
                                                setIgstError("IGST is required")
                                            } else if (![0, 5, 12, 18, 28].includes(parseFloat(value))) {
                                                setCgstError("Invalid CGST value")
                                                setSgstError("Invalid SGST value")
                                                setIgstError("Invalid IGST value")
                                            } else {
                                                setCgstError("")
                                                setSgstError("")
                                                setIgstError("")
                                            }
                                        }}
                                    />
                                    <span className='input-error-text'>{igstError}</span>
                                </div>
                            </div>
                            <span className='view-records-button' role='button'
                                onClick={() => {
                                    setViewTaxRatesModal(true)
                                    getTaxRates(serviceDetails?.service?.service_code)
                                }} 
                            >View previous records</span>
                        </div>
                        {edit && <div className='d-flex flex-column mt-3'>
                            <label className='add-facility-modal-label form-label-effective-from'>Effective from<span className='required-mark'>*</span></label>
                            <DatePicker
                                disabled={!edit}
                                className="admin-controls-date-picker form-control responsive-add-facility-input-fields custom-datepicker"
                                placeholderText="Select Period"
                                selected={taxRatesBillingFilter}
                                onChange={(date) => setTaxRatesBillingFilter(date)}
                                showMonthYearPicker
                                dateFormat="MMM yyyy"
                            />
                        </div>}
                        <hr />
                    </div>
                </div>
                <div className="infoFotter">
                    <div className="button-group d-flex justify-content-end gap-3">
                        <button className="btn btn-primary secondary-button" onClick={() => {
                            props.setPage(1)
                            dispatch({
                                type: GET_SERVICE_DETAILS_SUCCESS,
                                payload: null
                            })
                        }}>Back</button>
                        <button className="btn btn-primary primary-button " onClick={() => setEdit(!edit)}>{edit ? "Cancel" : "Edit"}</button>
                        {edit && <button className="btn btn-primary primary-button" disabled={
                            hsnCodeError !== "" || cgstError !== "" || sgstError !== "" || igstError !== "" || !(serviceDetails?.tax_rates?.tds_percentage)
                            || !(serviceDetails?.service?.uom)
                        } onClick={handleUpdateService}>Update</button>}
                    </div>
                </div>
            </div>

            {getServiceDetailsError && <Modal keyboard={false} backdrop="static" show={getServiceDetailsError} onHide={() => {
                dispatch({
                    type: GET_SERVICE_DETAILS_FAILURE,
                    payload: null
                })
            }} centered className="popper-modal">
                <Modal.Body className="text-center">
                    <MdErrorOutline className='error-warn'/>
                    <h5>Error!</h5>
                    <p className="mb-3">{getServiceDetailsError}</p>
                </Modal.Body>
                <Modal.Footer className="d-flex justify-content-center" >
                    <Button variant="secondary" className="secondary" onClick={() => {
                        dispatch({
                            type: GET_SERVICE_DETAILS_FAILURE,
                            payload: null
                        })
                    }} >
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>}
            {updateServiceSuccess && <Modal keyboard={false} backdrop="static" show={updateServiceSuccess} onHide={() => {
                dispatch({
                    type: UPDATE_SERVICE_DETAILS_SUCCESS,
                    payload: null
                })
            }} centered className="popper-modal">
                <Modal.Body className="text-center">
                    <img src="./images/icons/popper.svg" alt="Party Popper" />
                    <h5>Success!</h5>
                    <p className="mb-3">{updateServiceSuccess}</p>
                </Modal.Body>
                <Modal.Footer className="d-flex justify-content-center" >
                    <Button variant="secondary" className="secondary" onClick={() => {
                        dispatch({
                            type: UPDATE_SERVICE_DETAILS_SUCCESS,
                            payload: null
                        })
                        props.setReload(true)
                        props.setPage(1)
                    }} >
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>}
            {updateServiceError && <Modal keyboard={false} backdrop="static" show={updateServiceError} onHide={() => {
                dispatch({
                    type: UPDATE_SERVICE_DETAILS_FAILURE,
                    payload: null
                })
            }} centered className="popper-modal">
                <Modal.Body className="text-center">
                    <MdErrorOutline className='error-warn' />
                    <h5>Error!</h5>
                    <p className="mb-3">{updateServiceError}</p>
                </Modal.Body>
                <Modal.Footer className="d-flex justify-content-center" >
                    <Button variant="secondary" className="secondary" onClick={() => {
                        dispatch({
                            type: UPDATE_SERVICE_DETAILS_FAILURE,
                            payload: null
                        })
                    }} >
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>}
            {viewHsnRecordsModal && <Modal keyboard={false} backdrop="static" size='lg' show={viewHsnRecordsModal} onHide={() => setViewHsnRecordsModal(false)} centered className="popper-modal">
                <Modal.Body className="text-center">
                    <h5>Previous HSN Records</h5>
                    <div className='table-wrapper'>
                        <TableComponent
                            headers={[{
                                name: "Service Code",
                                type: "text",
                                key: "service_code"
                            }, {
                                name: "HSN Code",
                                type: "text",
                                key: "hsn_code"
                            }, {
                                name: "Start Date",
                                type: "date",
                                key: "start_date"
                            }, {
                                name: "End Date",
                                type: "date",
                                key: "end_date"
                            }, {
                                name: "Updated By",
                                type: "text",
                                key: "updated_by"
                            }, {
                                name: "Last Updated At",
                                type: "time_stamp",
                                key: "updated_at"
                            }]}
                            data={hsnCodes}
                        />
                    </div>
                </Modal.Body>
                <Modal.Footer className="d-flex justify-content-center" >
                    <Button variant="secondary" className="secondary" onClick={() => setViewHsnRecordsModal(false)} >
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>}
            {hsnCodeErrorModal && <Modal keyboard={false} backdrop="static" show={hsnCodeErrorModal} onHide={() => setHsnCodeErrorModal(null)} centered className="popper-modal">
                <Modal.Body className="text-center">
                    <MdErrorOutline className='error-warn' />
                    <h5>Error!</h5>
                    <p className="mb-3">{hsnCodeErrorModal}</p>
                </Modal.Body>
                <Modal.Footer className="d-flex justify-content-center" >
                    <Button variant="secondary" className="secondary" onClick={() => setHsnCodeErrorModal(null)} >
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>}
            {viewTaxRatesModal && <Modal keyboard={false} backdrop="static" size='lg' show={viewTaxRatesModal} onHide={() => setViewTaxRatesModal(false)} centered className="popper-modal">
                <Modal.Body className="text-center">
                    <h5>Previous Tax Rates Records</h5>
                    <div className='table-wrapper'>
                        <TableComponent
                            headers={[{
                                name: "Service Code",
                                type: "text",
                                key: "service_code"
                            }, {
                                name: "CGST",
                                type: "number",
                                key: "cgst",
                                formatNumberWithComas: true
                            }, {
                                name: "SGST",
                                type: "number",
                                key: "sgst",
                                formatNumberWithComas: true
                            }, {
                                name: "IGST",
                                type: "number",
                                key: "igst",
                                formatNumberWithComas: true
                            }, {
                                name: "Start Date",
                                type: "date",
                                key: "start_date"
                            }, {
                                name: "End Date",
                                type: "date",
                                key: "end_date"
                            }, {
                                name: "Updated By",
                                type: "text",
                                key: "updated_by"
                            }, {
                                name: "Last Updated At",
                                type: "time_stamp",
                                key: "updated_at"
                            }]}
                            data={taxRates}
                        />
                    </div>
                </Modal.Body>
                <Modal.Footer className="d-flex justify-content-center" >
                    <Button variant="secondary" className="secondary" onClick={() => setViewTaxRatesModal(false)} >
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>}
            {taxRatesError && <Modal keyboard={false} backdrop="static" show={taxRatesError} onHide={() => setTaxRatesError(null)} centered className="popper-modal">
                <Modal.Body className="text-center">
                    <MdErrorOutline className='error-warn' />
                    <h5>Error!</h5>
                    <p className="mb-3">{taxRatesError}</p>
                </Modal.Body>
                <Modal.Footer className="d-flex justify-content-center" >
                    <Button variant="secondary" className="secondary" onClick={() => setTaxRatesError(null)} >
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>}
            {viewInvoiceTermsModal && <Modal keyboard={false} backdrop="static" size='lg' show={viewInvoiceTermsModal} onHide={() => setViewInvoiceTermsModal(false)} centered className="popper-modal">
                <Modal.Body className="text-center">
                    <h5>Previous Invoice Terms Records</h5>
                    <div className='table-wrapper'>
                        <TableComponent
                            headers={[{
                                name: "Service Code",
                                type: "text",
                                key: "service_code"
                            }, {
                                name: "Document Type",
                                type: "text",
                                key: "document_type"
                            }, {
                                name: "Document Name",
                                type: "document",
                                key: "document_key"
                            }, {
                                name: "Start Date",
                                type: "date",
                                key: "start_date"
                            }, {
                                name: "End Date",
                                type: "date",
                                key: "end_date"
                            }, {
                                name: "Updated By",
                                type: "text",
                                key: "updated_by"
                            }, {
                                name: "Last Updated At",
                                type: "time_stamp",
                                key: "updated_at"
                            }]}
                            data={invoiceTerms}
                        />
                    </div>
                </Modal.Body>
                <Modal.Footer className="d-flex justify-content-center" >
                    <Button variant="secondary" className="secondary" onClick={() => setViewInvoiceTermsModal(false)} >
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>}
            {invoiceTermsError && <Modal keyboard={false} backdrop="static" show={invoiceTermsError} onHide={() => setInvoiceTermsError(null)} centered className="popper-modal">
                <Modal.Body className="text-center">
                    <MdErrorOutline className='error-warn' />
                    <h5>Error!</h5>
                    <p className="mb-3">{invoiceTermsError}</p>
                </Modal.Body>
                <Modal.Footer className="d-flex justify-content-center" >
                    <Button variant="secondary" className="secondary" onClick={() => setInvoiceTermsError(null)} >
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>}
            {loading && <Loader />}
            <Footer />
        </div>

    )
}
